type faqMapType = {
    [key: string]: any
}

type UIType = {
    [key: string]: any
}

export default class TranslationKeys {
    public static readonly FAQ : faqMapType= {
       ERC: {
           FAQ_ERC_ANSWER1_US: 'faq_answer_erc_contact_UnitedStates',
           FAQ_ERC_ANSWER1_US_CONTACT: 'faq_answer_erc_contact_UnitedStatesContact',
           FAQ_ERC_ANSWER1_UK: 'faq_answer_erc_contact_UnitedKingdom',
           FAQ_ERC_ANSWER1_UK_CONTACT: 'faq_answer_erc_contact_UnitedKingdomContact',
           FAQ_ERC_ANSWER1_CA: 'faq_answer_erc_contact_Canada',
           FAQ_ERC_ANSWER1_CA_CONTACT: 'faq_answer_erc_contact_CanadaContact',
           FAQ_ERC_ANSWER1_COSTA_RICA: 'faq_answer_erc_contact_CostaRica',
           FAQ_ERC_ANSWER1_COSTA_RICA_CONTACT: 'faq_answer_erc_contact_CostaRicaContact',
           FAQ_ERC_ANSWER1_CZECH: 'faq_answer_erc_contact_CzechRepublic',
           FAQ_ERC_ANSWER1_CZECH_CONTACT: 'faq_answer_erc_contact_CzechRepublicContact',
           FAQ_ERC_ANSWER1_IRELAND: 'faq_answer_erc_contact_Ireland',
           FAQ_ERC_ANSWER1_IRELAND_CONTACT: 'faq_answer_erc_contact_IrelandContact',
           FAQ_ERC_ANSWER1_POLAND: 'faq_answer_erc_contact_Poland',
           FAQ_ERC_ANSWER1_POLAND_CONTACT: 'faq_answer_erc_contact_PolandContact',
           FAQ_ERC_ANSWER1_SOUTH_AFRICA: 'faq_answer_erc_contact_SouthAfrica',
           FAQ_ERC_ANSWER1_SOUTH_AFRICA_CONTACT: 'faq_answer_erc_contact_SouthAfricaContact',
           FAQ_ERC_ANSWER1_INDIA: 'faq_answer_erc_contact_India',
           FAQ_ERC_ANSWER1_INDIA_CONTACT: 'faq_answer_erc_contact_IndiaContact',
           FAQ_ERC_ANSWER1_GERMANY: 'faq_answer_erc_contact_Germany',
           FAQ_ERC_ANSWER1_GERMANY_CONTACT: 'faq_answer_erc_contact_GermanyContact',
           FAQ_ERC_ANSWER1_FRANCE: 'faq_answer_erc_contact_France',
           FAQ_ERC_ANSWER1_FRANCE_CONTACT: 'faq_answer_erc_contact_FranceContact',
           FAQ_ERC_ANSWER1_ITALY: 'faq_answer_erc_contact_Italy',
           FAQ_ERC_ANSWER1_ITALY_CONTACT: 'faq_answer_erc_contact_ItalyContact',
           FAQ_ERC_ANSWER1_SLOVAKIA: 'faq_answer_erc_contact_Slovak',
           FAQ_ERC_ANSWER1_SLOVAKIA_CONTACT: 'faq_answer_erc_contact_SlovakContact',
           FAQ_ERC_ANSWER1_SPAIN: 'faq_answer_erc_contact_Spain',
           FAQ_ERC_ANSWER1_SPAIN_CONTACT: 'faq_answer_erc_contact_SpainContact',
           FAQ_ERC_ANSWER1_AUSTRALIA: 'faq_answer_erc_contact_Australia',
           FAQ_ERC_ANSWER1_AUSTRALIA_CONTACT: 'faq_answer_erc_contact_AustraliaContact',
           FAQ_ERC_ANSWER1_BAHRAIN: 'faq_answer_erc_contact_Bahrain',
           FAQ_ERC_ANSWER1_BAHRAIN_CONTACT: 'faq_answer_erc_contact_BahrainContact',
           FAQ_ERC_ANSWER1_BELGIUM: 'faq_answer_erc_contact_Belgium',
           FAQ_ERC_ANSWER1_BELGIUM_CONTACT: 'faq_answer_erc_contact_BelgiumContact',
           FAQ_ERC_ANSWER1_CHINA: 'faq_answer_erc_contact_China',
           FAQ_ERC_ANSWER1_CHINA_CONTACT: 'faq_answer_erc_contact_ChinaContact',
           FAQ_ERC_ANSWER1_EGYPT: 'faq_answer_erc_contact_Egypt',
           FAQ_ERC_ANSWER1_EGYPT_CONTACT: 'faq_answer_erc_contact_EgyptContact',
           FAQ_ERC_ANSWER1_FINLAND: 'faq_answer_erc_contact_Finland',
           FAQ_ERC_ANSWER1_FINLAND_CONTACT: 'faq_answer_erc_contact_FinlandContact',
           FAQ_ERC_ANSWER1_JAPAN: 'faq_answer_erc_contact_Japan',
           FAQ_ERC_ANSWER1_JAPAN_CONTACT: 'faq_answer_erc_contact_JapanContact',
           FAQ_ERC_ANSWER1_MEXICO: 'faq_answer_erc_contact_Mexico',
           FAQ_ERC_ANSWER1_MEXICO_CONTACT: 'faq_answer_erc_contact_MexicoContact',
           FAQ_ERC_ANSWER1_MOROCCO: 'faq_answer_erc_contact_Morocco',
           FAQ_ERC_ANSWER1_MOROCCO_CONTACT: 'faq_answer_erc_contact_MoroccoContact',
           FAQ_ERC_ANSWER1_NETHERLANDS: 'faq_answer_erc_contact_Netherlands',
           FAQ_ERC_ANSWER1_NETHERLANDS_CONTACT: 'faq_answer_erc_contact_NetherlandsContact',
           FAQ_ERC_ANSWER1_NEW_ZEALAND: 'faq_answer_erc_contact_NewZealand',
           FAQ_ERC_ANSWER1_NEW_ZEALAND_CONTACT: 'faq_answer_erc_contact_NewZealandContact',
           FAQ_ERC_ANSWER1_PHILIPPINES: 'faq_answer_erc_contact_Philippines',
           FAQ_ERC_ANSWER1_PHILIPPINES_CONTACT: 'faq_answer_erc_contact_PhilippinesContact',
           FAQ_ERC_ANSWER1_ROMANIA: 'faq_answer_erc_contact_Romania',
           FAQ_ERC_ANSWER1_ROMANIA_CONTACT: 'faq_answer_erc_contact_RomaniaContact',
           FAQ_ERC_ANSWER1_SINGAPORE: 'faq_answer_erc_contact_Singapore',
           FAQ_ERC_ANSWER1_SINGAPORE_CONTACT: 'faq_answer_erc_contact_SingaporeContact',
           FAQ_ERC_ANSWER1_SWEDEN: 'faq_answer_erc_contact_Sweden',
           FAQ_ERC_ANSWER1_SWEDEN_CONTACT: 'faq_answer_erc_contact_SwedenContact',
           FAQ_ERC_ANSWER1_SWITZERLAND: 'faq_answer_erc_contact_Switzerland',
           FAQ_ERC_ANSWER1_SWITZERLAND_CONTACT: 'faq_answer_erc_contact_SwitzerlandContact',
           FAQ_ERC_ANSWER1_UNITED_EMIRATES: 'faq_answer_erc_contact_UnitedArabEmirates',
           FAQ_ERC_ANSWER1_UNITED_EMIRATES_CONTACT: 'faq_answer_erc_contact_UnitedArabEmiratesContact',
       }
    }
    public static readonly UI : UIType = {
       ALUMNI: {
           WELCOME_HEADER: 'alumni_welcome_heading',
           WELCOME_DESCRIPTION: 'alumni_welcome_description',
           SETUP_STEP1: 'alumni_setup_step_1',
           SETUP_STEP2: 'alumni_setup_step_2',
           SETUP_STEP3: 'alumni_setup_step_3',
           SETUP_ALTERNATE_CONTACT: 'alumni_setup_alternate_contact',
           CONTACT_INFO_HEADER: 'alumni_contact_info_heading',
           CONTACT_INFO_EMAIL_HEADER: 'alumni_contact_email_heading',
           CONTACT_INFO_EMAIL_ALTERNATE: 'alumni_contact_email_alternate',
           CONTACT_INFO_PHONE_HEADER: 'alumni_contact_phone_heading',
           CONTACT_INFO_PHONE_ALTERNATE: 'alumni_contact_phone_alternate',
           HELP_HEADER: 'alumni_help_topHeading',
           HELP_DESCRIPTION: 'alumni_help_description',
           GENERIC_ERROR_MESSAGE: 'generic_error',
           GENERIC_ERROR_LINK: 'generic_error_cta'
       },
       BUTTONS: {
           BACK: 'back_btn',
           SAVE: 'save_btn',
           SUBMIT: 'submit_btn',
           CONTACT_US: 'contact_us',
           START: 'start_btn'
       }
    }
    public static readonly FOOTER = {
        LANGUAGE: {
            CHANGE_LANGUAGE: 'change_language',
            CHOOSE_LANGUAGE: 'choose_language',
            CHANGE_LANGUAGE_HEADER: 'change_language_header'
        },
        CONTACT_US: 'contact_us'
    };
}